import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { GlobalSearch } from "../components/GlobalSearch";
import { PageHeader } from "../components/PageHeader";
import { SearchResults } from "../components/SearchResults";
import { searchAll } from "../lib/search";

export function SearchPage() {
  const [searchParams] = useSearchParams();
  const initialQuery = searchParams.get("q") ?? "";
  const [query, setQuery] = useState(initialQuery);
  const results = useMemo(() => searchAll(query), [query]);

  return (
    <div className="page">
      <PageHeader eyebrow="Глобальный поиск" title="Поиск по базе знаний" description="Факты, формулировки, паспорт и бренд-материалы — в одном месте." />
      <GlobalSearch initialValue={initialQuery} onQueryChange={setQuery} autoFocus={!initialQuery} />
      <div className="search-page-meta">{query ? `Найдено результатов: ${results.length}` : "Введите запрос, чтобы начать поиск"}</div>
      <SearchResults query={query} results={results} />
    </div>
  );
}
